import { RootState } from "../../store/types";
import { AppDispatch } from "../../store";
import { connect } from "react-redux";
import VolumesAndWip from "./index";
import { getTargetAndWipVolumeThunk } from "../../store/slices/volumesAndWipSlice";
import { fetchDryRunShiftPlan, generatePlanThunk } from "../../store/slices/checkoutSlice";
import { resetShiftPlanOutput } from "../../store/slices/reviewAndPublishSlice";
import { GetTargetAndWIPVolumeRequest } from "./model";
import { RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB } from "../../utils/metric-utils";

// Own props passed by the parent. `planId` is optional: when provided (e.g. the
// published-plan page rendering a specific version) it overrides the active-workflow
// plan; when omitted, the workflow plan from shiftPlanSlice is used, so the normal
// Volumes & WIP step and Review & Publish are unaffected.
interface VolumesAndWipOwnProps {
    readOnly?: boolean;
    planId?: string | null;
    // Published-plan page clears the shiftPlan slice post-publish, so these must be
    // supplied explicitly there; each falls back to the slice for the normal workflow.
    date?: string | null;
    shiftType?: string | null;
    stationCode?: string | null;
    // Origin of the request (e.g. "PUBLISHED_PLAN"), forwarded to the backend so a
    // CLOSED published plan can be viewed. Own prop → flows straight to the component.
    source?: string;
}

const mapStateToProps = (state: RootState, ownProps?: VolumesAndWipOwnProps) => ({
    targetAndWIPVolume: state.volumesAndWip.targetAndWIPVolume,
    planId: ownProps?.planId ?? state.shiftPlan.planId,
    date: ownProps?.date ?? state.shiftPlan.selectedDate,
    shiftType: ownProps?.shiftType ?? state.shiftPlan.selectedShift,
    stationCode: ownProps?.stationCode ?? state.shiftPlan.stationCode,
    isCheckoutEnabled: state.checkout.isCheckoutEnabled ?? false,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getTargetAndWipVolume: (getTargetAndWipVolumeRequest: GetTargetAndWIPVolumeRequest) =>
        dispatch(getTargetAndWipVolumeThunk(getTargetAndWipVolumeRequest)),
    verifyVolumes: async () => 
        await dispatch(fetchDryRunShiftPlan()),
    generatePlan: async (planId: string) =>
        await dispatch(generatePlanThunk({ planId, pageId: RCC_SHIFT_PLAN_VOLUMES_AND_WIP_TAB })),
    resetShiftPlanOutput: () => dispatch(resetShiftPlanOutput())
});

export default connect(mapStateToProps, mapDispatchToProps)(VolumesAndWip);
